export const environment = {
  production: true,
  apiUrl: 'https://createmydatabook-processor.sbp.eyclienthub.com/api/',
  usApiUrl: 'https://createmydatabook-us-processor.sbp.eyclienthub.com/api/',
  apacApiUrl: 'https://createmydatabook-aus-processor.sbp.eyclienthub.com/api/',
  pageRows: 10,
  pageRows25: 25,
  maxFilesUploads: 5,
  concurrentUploads: 2,
  maxFileSize: 6, // in MB
  maxSourceFileSize: 10, // in MB
  maxFlatFileSizeUploadLimit: 20,
  minFlatFileSizeToSendEmail: 6144, // in KB =6MB
  maxPreviewFileSize: 512000,//500 KB
  env: 'prod',
  pageSize: 1000,
  tenant: 'eygs.onmicrosoft.com',
  clientId: '741f16b2-6c2b-43e0-a2a3-5c01ce0d652c',
  redirectUri: window.location.origin,
  postLogoutRedirectUri: window.location.origin,
  extraQueryParameter: 'domain_hint = eyclienthub.com',
  authority: 'https://login.microsoftonline.com/eygs.onmicrosoft.com',
  isWebJobEnabled: true,
  webjobTimer: 15000,
  isBearerAuthorizationEnabled: true, 
  isMsalEnabled : true,  
  sampleToken: '000',
  webAppUrl: 'https://createmydatabook.sbp.eyclienthub.com',
  sessionTimeout: 3540, // in seconds
  version: '16/07/2022 01:20:04 AM EST',
  processorVersion: 'v3.1',
  ENV: 'Prod',
  supportedLangs: [{ name: 'English', code: 'en-US' }]
};
